import { KeyboardBackspace } from "@mui/icons-material";
import {
  Divider,
  IconButton,
  Stack,
  StackProps,
  Typography,
} from "@mui/material";
import { ReactNode } from "react";
import { useNavigate } from "react-router-dom";

interface Props extends StackProps {
  children: ReactNode;
}

const ExpandedView = ({ children, sx, padding, borderRadius }: Props) => {
  const navigate = useNavigate();

  return (
    <Stack
      gap={1}
      height={window.innerHeight - 42 - 24 - 24}
      sx={sx}
      padding={padding}
      borderRadius={borderRadius}
    >
      <Stack direction="row" gap={1} alignItems="center">
        <IconButton size="small" color="inherit" onClick={() => navigate(-1)}>
          <KeyboardBackspace fontSize="large" />
        </IconButton>
        <Typography fontWeight={700} variant="h6">
          {"Back"}
        </Typography>
      </Stack>
      <Divider
        sx={{
          backgroundColor: "#E4E7EE",
          mt: 2,
        }}
      />
      {children}
    </Stack>
  );
};

export default ExpandedView;
